/* eslint-disable indent */

export const getAriaProps = <T extends Record<string, unknown> = Record<string, unknown>>(props: T): AriaProps =>
  Object.fromEntries(Object.entries(props).filter(([key]) => key.startsWith('aria-'))) as AriaProps;

export const getDataProps = <T extends Record<string, unknown> = Record<string, unknown>>(props: T): DataProps =>
  Object.fromEntries(Object.entries(props).filter(([key]) => key.startsWith('data-'))) as DataProps;

export const getAriaOrDataProps = <T extends Record<string, unknown> = Record<string, unknown>>(
  props: T,
): AriaAndDataProps =>
  Object.fromEntries(
    Object.entries(props).filter(([key]) => key.startsWith('aria-') || key.startsWith('data-')),
  ) as AriaAndDataProps;
